function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { colors, fonts } from '../../../theme';
import { createOwnUpStyle } from '../../style';
export var OwnUpPhoneInputStyle = createOwnUpStyle(_objectSpread(_objectSpread({}, fonts.GRAPHIK_REGULAR), {}, {
  fontSize: '16px',
  color: colors.PRIMARY,
  backgroundColor: colors.TRANSPARENT,
  position: 'absolute',
  border: 'none',
  marginTop: 28,
  marginLeft: 18,
  paddingTop: 0,
  ':focus': {
    outline: 'none'
  },
  variants: {
    standalone: {
      backgroundColor: colors.WHITE
    }
  }
}));